module.exports = __webpack_public_path__ + "f4018d222f0984e8d927f20fcb5d80f3.svg";